import { useState } from "react";
import { TermsOfServiceDialog } from "./TermsOfServiceDialog";

export const Footer = () => {
	const [isTermsDialogOpen, setIsTermsDialogOpen] = useState(false);

	const handleOpenTermsDialog = () => {
		setIsTermsDialogOpen(true);
	};

	const handleCloseTermsDialog = () => {
		setIsTermsDialogOpen(false);
	};

	return (
		<footer>
			<p style={{ marginLeft: "10px" }}>
				2025 In-House Health, Inc. All rights reserved.{" "}
				<a href="#" onClick={handleOpenTermsDialog}>
					Terms of Service
				</a>
				{" | Privacy Policy"}
			</p>
			<TermsOfServiceDialog open={isTermsDialogOpen} onClose={handleCloseTermsDialog} />
		</footer>
	);
};
